import React from "react";
import {Button, Input, message, Modal,Select} from "antd";
const Option = Select.Option;
import moment from "moment";
import {WWUtils,WWMethods,wwConstants} from "@/tools";
import AuthButton from "../antdReset/AuthButton";
const {TextArea} = Input;
moment.locale("zh-cn");
import "@/assets/styles/modal.scss"
class WarningModalHandle extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            defineOneShow: false,
            recordrow: {},
            isFreeAccount: localStorage.getItem("isFreeAccount") == "1",
            judgeType: "",
            alarmTypeName: "",
            deviceName: "",
            remark: "",
            res: {},
            imei: '',
            alarmId: "",
            alarmType: "",
        };
        this.hideModal = this.hideModal.bind(this);
        this.showModal = this.showModal.bind(this);
        this.submit = this.submit.bind(this);
    }

    showModal(record) {
        this.setState({
            alarmId: record.id,
            judgeType: record.handle,
            remark: record.handleRemark,
            defineOneShow: true,
        });

    }

    hideModal() {
        this.setState({
            defineOneShow: false,
            remark: '',
            judgeType: '',
            alarmId:""
        });
    }

    submit() {
        const { judgeType, remark, alarmId} =
            this.state;
        if (!judgeType) {
            message.error(Strings.rs11063);
            return;
        }
        let model = {
            handle:judgeType,
            handleRemark:remark,
            ids: [alarmId],
        };
        let url = WWMethods.getApiUrl("alarmHandle");
        let that = this;
        WWUtils.fetch(url, "POST", model, function (data) {
            if (data.code === 0) {
                message.success(Strings.rs11064);
                that.props.refresh();
                that.hideModal();
            } else {
                message.error(data.message);
            }
        });
    }

    render() {
        const {defineOneShow, info, res, alarmTypeName, imei, judgeType, remark} = this.state;
        return <Modal transitionName="" maskTransitionName=""
                      visible={defineOneShow}
                      onCancel={this.hideModal}
                      title={Strings.rs11059}
                      width={400}
                      footer={null}
                      className="default_modal wid650">
            <div className="onlyOneRow modal_item">
                <span className="labelfont">{Strings.rs11063}</span>
                <div className="form_value">
                    <Select value={judgeType?judgeType.toString():""}
                            onChange={(value) => {
                                this.setState({judgeType: value})
                            }}
                            style={{width: 240}}>
                        {WWUtils.getOptionsFromGlobalEnums("enums.alarmHandle","select")}
                    </Select>
                </div>
            </div>
            <div className="onlyOneRow modal_item">
                <span className="labelfont">{Strings["prop.common.remark"]}</span>
                <div className="form_value">
                    <Input.TextArea
                        value={remark}
                        style={{
                            height: 100,
                            resize: 'none',
                            width:'240px'
                        }}
                        maxLength={256}
                        onChange={(e) => {
                            this.setState({
                                remark: e.target.value
                            })
                        }}
                    />
                </div>
            </div>
            <div className="btn-row mg_top5">
                <AuthButton type={"reset"} authKey={true} onClick={this.hideModal}>{Strings.cancel}</AuthButton>
                <AuthButton type="primary" className={"mgl10"} authKey={true} onClick={this.submit}>{Strings.sure}</AuthButton>
            </div>
        </Modal>
    }
}

export default WarningModalHandle;
